/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import React from 'react';
import './App.css';
import { Home } from './layout/Home';
import { usePrivateRoute } from '@ink-ai/portal/common/hooks/usePrivateRoute';
import { useAutoRefreshToken } from '../common/hooks/useAutoRefreshToken';
import { useSyncSelectedData } from '../common/hooks/useSyncSelectedData';
import { SocketLoading } from '../common/socket/SocketLoading';

function App() {
  usePrivateRoute();
  useAutoRefreshToken();
  useSyncSelectedData();
  return (
    <div className="App">
      <Home />
      <SocketLoading />
    </div>
  );
}

export default App;
